import jfetch from '@jontetz/jfetch';

export function getProductsWithChemicalCodeByItemNumber(params) {
    return jfetch.get(`/api/product/getproductswithchemicalcodebyitemnumber`, params);
}